import { ChildDeactivationRequest } from "@core/models/domain/child-deactivation.domain";

export interface ChildDeactivationState {
  requests: ChildDeactivationRequest[];
  /** Requests the school has already decided, shown as history for audit. */
  resolvedRequests: ChildDeactivationRequest[];
  loading: boolean;
  loadingResolved: boolean;
  error: string | null;
  // Id of the request currently being decided, so the page can disable its buttons.
  actionInProgressId: string | null;
  // Ids optimistically added to resolvedRequests on a decision, mapped to when that happened.
  // Shields them from a history reload that raced the backend read model and came back without them.
  recentLocalDecisions: Record<string, number>;
}

export const initialChildDeactivationState: ChildDeactivationState = {
  requests: [],
  resolvedRequests: [],
  loading: false,
  loadingResolved: false,
  error: null,
  actionInProgressId: null,
  recentLocalDecisions: {},
};
